import React, { useState } from 'react';
import {
  Box,
  Tabs,
  Tab,
  Typography,
  alpha,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import EmailSettings from './EmailSettings';
import UserManagement from './UserManagement';
import IPBlocking from './IPBlocking';
import { GlassContainer } from '../styles/sharedStyles';
import { useTranslation } from 'react-i18next';

const SecuritySettings = ({ apiBaseUrl, token, userInfo }) => {
  const { t } = useTranslation();
  const [activeSubTab, setActiveSubTab] = useState(0);

  return (
    <Box>
      {/* Sub-tabs for Security */}
      <GlassContainer
        sx={{
          borderRadius: { xs: '16px', sm: '24px' },
        }}
      >
        {/* Sub-tab Navigation */}
        <Box
          sx={{
            borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
            background: 'rgba(255, 255, 255, 0.02)',
            px: 0,
            overflowX: { xs: 'auto', sm: 'unset' },
          }}
        >
          <Tabs
            value={activeSubTab}
            onChange={(e, newValue) => setActiveSubTab(newValue)}
            variant="scrollable"
            scrollButtons="auto"
            sx={{
              minHeight: { xs: '48px', sm: '56px' },
              '& .MuiTabs-indicator': {
                background: (theme) => theme.palette.primary.main,
                height: '3px',
              },
              '& .MuiTab-root': {
                color: 'rgba(255, 255, 255, 0.6)',
                textTransform: 'none',
                fontSize: { xs: '0.75rem', sm: '0.9rem' },
                fontWeight: 500,
                py: { xs: 1, sm: 1.5 },
                px: { xs: 1.5, sm: 2.5 },
                minWidth: { xs: 'auto', sm: '100px' },
                transition: 'all 0.3s ease',
                '&:hover': {
                  color: '#ffffff',
                  background: 'rgba(255, 255, 255, 0.05)',
                },
                '&.Mui-selected': {
                  color: (theme) => theme.palette.primary.main,
                  background: (theme) => alpha(theme.palette.primary.main, 0.05),
                },
              },
            }}
          >
            <Tab label={t('security.email')} />
            <Tab label={t('security.usersTab')} />
            <Tab label={t('security.ipBlockingTab')} />
          </Tabs>
        </Box>

        {/* Sub-tab Content */}
        <Box sx={{ p: { xs: 1, sm: 2, md: 3 } }}>
          {/* Email Sub-tab */}
          {activeSubTab === 0 && (
            <Box>
              <EmailSettings apiBaseUrl={apiBaseUrl} token={token} />
            </Box>
          )}

          {/* Users Sub-tab */}
          {activeSubTab === 1 && (
            <Box>
              <UserManagement apiBaseUrl={apiBaseUrl} token={token} userInfo={userInfo} />
            </Box>
          )}

          {/* IP Blocking Sub-tab */}
          {activeSubTab === 2 && (
            <Box>
              <IPBlocking apiBaseUrl={apiBaseUrl} token={token} />
            </Box>
          )}
        </Box>
      </GlassContainer>
    </Box>
  );
};

export default SecuritySettings;
